import { createContext, useContext } from 'react';
import { fullStoryService } from '../../services/apiService';

// Which backend the Full Story steps talk to. Full Story itself uses the
// default; Full Story Video provides its own service (same method names) so
// the Voice and Video steps and the effect picker are shared, not copied.
export const FullStoryApiContext = createContext(fullStoryService);

export const useFullStoryApi = () => useContext(FullStoryApiContext);
